<template lang="pug">
  y-chip.round-xl.d-block.pa-4(outlined)
    v-row.align-center.mb-2(no-gutters)
      v-col(cols="6")
        .text-sm.text-left Customer:
      v-col
        .text-sm.text-left.font-medium(v-if="name") {{ name }}
        .text-sm.text-left.neutral500--text(v-else) No name
    v-row.align-center(no-gutters)
      v-col(cols="6")
        .text-sm.text-left Phone number:
      v-col
        .text-sm.text-left.font-medium +{{ phone }}
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    phone: {
      type: String,
      default: null
    },
  },
}
</script>

<style scoped>

</style>